import './load.scss';
type LazyLoaderProps = {
  className?: string
}
export default function LazyLoader({ className }: LazyLoaderProps) {
  return (
    <div className={`loader ${className ?? ''}`}></div>
  )
};
